function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { EntityUrlsQuery, Link, useLocation } from "@custom/schema";
import { motion } from "motion/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocalization } from "../../../utils/localization";
import { useOperation } from "../../../utils/operation";
export var ActionBar = function ActionBar(param) {
  var remoteId = param.remoteId;
  var _result_data;
  var locale = useLocalization().locale;
  var t = useTranslation().t;
  var _useLocation = _sliced_to_array(useLocation(), 1),
    location = _useLocation[0];
  var nodeId = (remoteId === null || remoteId === void 0 ? void 0 : remoteId.split(":")[1]) || undefined;
  var result = useOperation(EntityUrlsQuery, {
    language: locale,
    nodeId: nodeId,
    path: location === null || location === void 0 ? void 0 : location.pathname
  });
  var entityUrls = (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.entityUrls;
  return entityUrls ? /*#__PURE__*/React.createElement("div", {
    className: "fixed left-full top-[150px] z-50 hidden lg:block"
  }, /*#__PURE__*/React.createElement(motion.ul, {
    className: "relative shadow-action-bar group flex flex-col gap-[1px]",
    whileHover: "groupHover",
    initial: "initial"
  }, [{
    url: entityUrls.editForm,
    icon: /*#__PURE__*/React.createElement(AdminEdit, null),
    label: "Edit"
  }, {
    url: entityUrls.translations,
    icon: /*#__PURE__*/React.createElement(AdminTranslate, null),
    label: "Translate"
  }, {
    url: entityUrls.deleteForm,
    icon: /*#__PURE__*/React.createElement(AdminDelete, null),
    label: "Delete"
  }].map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, item.url ? /*#__PURE__*/React.createElement(motion.li, {
      key: item.label,
      role: "presentation",
      variants: {
        initial: {
          x: 0
        },
        groupHover: {
          x: "-100%"
        }
      },
      transition: {
        duration: 0.2,
        ease: "easeOut",
        delay: index * 0.1
      }
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.url,
      className: "h-[50px] pr-[30px] pl-[50px] -ml-[50px] flex items-center bg-primary-white relative hover:text-theme-dark",
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "absolute left-0 top-0 flex h-[50px] w-[50px] items-center justify-center"
    }, item.icon), t(item.label))) : null);
  }))) : null;
};
var AdminEdit = function AdminEdit() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 22,
    height: 22,
    viewBox: "0 0 48 48",
    className: "fill-current"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44.929 14.391a.955.955 0 0 1-.183.276L16.84 42.572a.95.95 0 0 1-.475.434l-13.852 3.88c-.029.014-.062.016-.094.026l-.047.014c-.008.003-.017.001-.024.004a1.06 1.06 0 0 1-.286.045.926.926 0 0 1-.282-.041c-.021-.006-.04-.002-.061-.009-.008-.003-.013-.01-.021-.013a.94.94 0 0 1-.24-.141c-.039-.028-.08-.053-.113-.086s-.058-.074-.086-.113a.952.952 0 0 1-.141-.24c-.004-.008-.01-.013-.013-.021-.007-.02-.003-.04-.009-.061a.985.985 0 0 1-.041-.281c0-.1.02-.193.045-.287.004-.008.001-.016.004-.023l.014-.049c.011-.03.013-.063.026-.093l3.88-13.852c.082-.216.246-.364.434-.475L32.937 3.71c.04-.045.087-.083.128-.127l.299-.299c.015-.015.034-.02.05-.034C34.858 1.87 36.796 1 38.953 1A8.047 8.047 0 0 1 47 9.047c0 2.061-.795 3.922-2.071 5.344zM41.15 15.5l-3.619-3.619-23.64 23.641c.004.008.014.011.018.019l2.373 4.827L41.15 15.5zM3.559 44.473l2.785-.779-2.006-2.005-.779 2.784zm1.384-4.943 3.558 3.559 6.12-1.715s-2.586-5.372-2.59-5.374l-5.374-2.59-1.714 6.12zm7.547-5.406c.008.004.011.013.019.018L36.15 10.5l-3.619-3.619L7.663 31.749l4.827 2.375zM38.922 3c-1.782 0-3.372.776-4.489 1.994l-.007-.007-.514.513 8.619 8.619.527-.528-.006-.006c1.209-1.116 1.979-2.701 1.979-4.476A6.109 6.109 0 0 0 38.922 3z",
    clipRule: "evenodd"
  }));
};
var AdminTranslate = function AdminTranslate() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 22,
    height: 22,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 25,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 12,
    ry: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M6.365 40.438C10.766 37.729 17.479 36 25 36c7.418 0 14.049 1.682 18.451 4.325M43.635 9.563C39.234 12.271 32.521 14 25 14c-7.417 0-14.049-1.682-18.451-4.325M1 25h48M25 1v48"
  }));
};
var AdminDelete = function AdminDelete() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "fill-current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 10.293l5.293-5.293.707.707-5.293 5.293 5.293 5.293-.707.707-5.293-5.293-5.293 5.293-.707-.707 5.293-5.293-5.293-5.293.707-.707 5.293 5.293z"
  }));
};